<template>
  <div class="modal open">
    <div class="modal__header show-for-small-only">
      <span class="title">
        <span>{{ $t('Filter') }}</span>
        <button class="close-button" aria-label="Close menu" type="button" data-close>
          <span aria-hidden="true"></span>
        </button>
      </span>
    </div>
    <div class="modal__content">
      <sub-categories :sub-categories="subCategories" :category-id="categoryId"></sub-categories>
      <attribute-filter
        v-for="filter in attributeFilters"
        :filter="filter"
        :key="filter.code"
        :data-source="dataSource"
      ></attribute-filter>
      <swatch-filter
        v-for="filter in swatchFilters"
        :filter="filter"
        :key="filter.code"
        :data-source="dataSource"
      ></swatch-filter>
      <price-filter
        v-for="filter in priceFilters"
        :filter="filter"
        :key="filter.code"
        :data-source="dataSource"
      ></price-filter>
    </div>
    <div class="modal__footer">
      <button class="_button _cta show-for-small-only" data-close="">
        <span aria-hidden="true">{{ activeFilterCount > 0 ? $tc('Show {totalItems} results', totalProductCount, {totalItems: totalProductCount}) : 'Show results' }}</span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'product-filter-list',
  components: {
    AttributeFilter: ServiceContainer().getComponent('attribute-filter'),
    priceFilter: ServiceContainer().getComponent('price-filter'),
    swatchFilter: ServiceContainer().getComponent('swatch-filter'),
    subCategories: ServiceContainer().getComponent('sub-categories')
  }
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({default: () => { return [] }}) readonly subCategories: Array<object>;
  @Prop({default: 0}) readonly categoryId: Number;
  @Prop() readonly categoryName: string;

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/productList`].length;
  }

  private get filterList(): Array<object> {
    return this.$store.getters[`${this.dataSource}/filterList`].filter(f => f.is_visible);
  }

  private get attributeFilters(): object {
    if (this.filterList) {
      return this.filterList.filter(item => {
        return item['type'] === 'attribute' && item['renderer'] !== 'swatch_visual';
      });
    }
    return {};
  }

  private get swatchFilters(): object {
    if (this.filterList) {
      return this.filterList.filter(item => {
        return item['renderer'] === 'swatch_visual';
      });
    }
    return {};
  }

  private get priceFilters(): object {
    return this.$store.getters[`${this.dataSource}/priceFilters`];
  }

  private get activeFilterCount(): number {
    return this.$store.getters[`${this.dataSource}/activeFilters`].length;
  }
}
</script>
